import { render, staticRenderFns } from "./IndicatorNew.vue?vue&type=template&id=3734f7c2&scoped=true"
import script from "./IndicatorNew.vue?vue&type=script&lang=js"
export * from "./IndicatorNew.vue?vue&type=script&lang=js"
import style0 from "./IndicatorNew.vue?vue&type=style&index=0&id=3734f7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734f7c2",
  null
  
)

export default component.exports